export default {
  userStatuses: {
    "confirmed": "Confirmé",
    "deleted": "Supprimé",
    "pending": "En attente"
  }
};
